import { Component, Input,EventEmitter, Output, OnInit } from '@angular/core';

@Component({
  selector: 'dskl-icon-menu',
  templateUrl: "icon-menu.component.html"
})
export class IconMenuComponent implements OnInit { 
    @Input() label="";
    @Output() selected=new EventEmitter();
    @Input() items=[];
    @Input() item:any={icon:''};
    @Input() up:false;
    ngOnInit(){
        if (this.items.length>0)
            this.item = this.items[0];
    }
    onSelect(e){
       
        this.item = e;
        this.selected.next(e);
    }
}



// WEBPACK FOOTER //
// /app/src/app/utils/menu/icon-menu.component.ts